import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { fadeAnimation } from '@erbfactors/shared-ui';
import { FormField } from '@erbfactors/util-forms';
import { isControlRequired } from '../../../helpers/is-control-required';
import { NumberField } from '../../../model/form-field.model';

@Component({
  selector: 'erbfactors-number-control',
  templateUrl: './number-control.component.html',
  styleUrls: ['./number-control.component.scss'],
  animations: [fadeAnimation],
})
export class NumberControlComponent implements OnInit {
  @Input() errors: { name: string; message: string }[] = [];

  @Input() showErrors = false;
  @Input() field: FormField;
  @Input() control: AbstractControl;
  @Input() form: FormGroup;
  required: boolean;
  styles: Partial<CSSStyleDeclaration>;
  ngOnInit() {
    this.styles = {
      display: 'flex',
      flexDirection: 'column',
      ...this.field.styles,
    };
    this.required = isControlRequired(this.control);
    if (this.required) {
      this.errors.push({
        name: 'required',
        message: 'Το πεδίο είναι υποχρεωτικό.',
      });
    }
  }
}
